/**
 * Created with setting codegen.
 */
import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * Setting to control the time we wait to refetch the product review incentive conductor components after being told the product review incentive is granted
 */
export const FE_INVALIDATE_PRODUCT_REVIEW_CONDUCTOR_CAMPAIGN_DELAY_MS_250828 =
  configuration({
    name: "FE_INVALIDATE_PRODUCT_REVIEW_CONDUCTOR_CAMPAIGN_DELAY_MS_250828",
    identifier: "RetailerTokenInSession",
    defaultValue: 3000,
    client: "RETAILER",
    productArea: "PRODUCT_REVIEWS",
  });
